import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";

import { AuthProvider } from "@/lib/auth";
import LoginModal from "@/components/LoginModal";

import CalculatorPage from "@/pages/CalculatorPage";
import LibraryPage from "@/pages/LibraryPage";
import InspirationPage from "@/pages/InspirationPage";
import ProductionPlanPage from "@/pages/ProductionPlanPage";
import ProductionHistoryPage from "@/pages/ProductionHistoryPage";
import ProductionPlanPreviewPage from "@/pages/ProductionPlanPreviewPage";
import QuickPurchasesPage from "@/pages/QuickPurchasesPage";
import InventoryCheckPage from "@/pages/InventoryCheckPage";
import RnDPage from "@/pages/RnDPage";
import SampleReportsPage from "@/pages/SampleReportsPage";
import DiscoverPage from "@/pages/DiscoverPage";
import AskMePage from "@/pages/AskMePage";
import GuidePage from "@/pages/GuidePage";
import MenuCreatorPage from "@/pages/MenuCreatorPage";
import MenuPreviewPage from "@/pages/MenuPreviewPage";
import IngredientsMasterPage from "@/pages/IngredientsMasterPage";
import MenuEngineeringPage from "@/pages/MenuEngineeringPage";
import InvoicePage from "@/pages/InvoicePage";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<CalculatorPage />} />
            <Route path="/library" element={<LibraryPage />} />
            <Route path="/inspiration" element={<InspirationPage />} />
            <Route path="/production" element={<ProductionPlanPage />} />
            <Route path="/production/history" element={<ProductionHistoryPage />} />
            <Route path="/production/preview/:id" element={<ProductionPlanPreviewPage />} />
            <Route path="/purchases" element={<QuickPurchasesPage />} />
            <Route path="/inventory-check" element={<InventoryCheckPage />} />
            <Route path="/rnd" element={<RnDPage />} />
            <Route path="/samples" element={<SampleReportsPage />} />
            <Route path="/discover" element={<DiscoverPage />} />
            <Route path="/menu" element={<MenuCreatorPage />} />
            <Route path="/menu/:id" element={<MenuPreviewPage />} />
            <Route path="/ingredients" element={<IngredientsMasterPage />} />
            <Route path="/engineering" element={<MenuEngineeringPage />} />
            <Route path="/invoice" element={<InvoicePage />} />
            <Route path="/askme" element={<AskMePage />} />
            <Route path="/guide" element={<GuidePage />} />
          </Routes>
          <LoginModal />
        </BrowserRouter>
        <Toaster position="top-right" richColors theme="light" />
      </AuthProvider>
    </div>
  );
}

export default App;
